if (!customElements.get('img-comparison-slider')) {
  customElements.define('img-comparison-slider', class ImgComparisonSlider extends HTMLElement {
    connectedCallback() {
      this._handle = this.querySelector('.ba-handle');
      this._pos = 50;
      this._dragging = false;

      this._onHandlePointerDown = this._onHandlePointerDown.bind(this);
      this._onPointerMove = this._onPointerMove.bind(this);
      this._onPointerUp   = this._onPointerUp.bind(this);
      this._onKeyDown     = this._onKeyDown.bind(this);

      if (this._handle) {
        this._handle.addEventListener('pointerdown', this._onHandlePointerDown);
        this._handle.addEventListener('keydown', this._onKeyDown);
      }
      this.addEventListener('pointermove', this._onPointerMove);
      this.addEventListener('pointerup',   this._onPointerUp);
      this.addEventListener('pointercancel', this._onPointerUp);
    }

    disconnectedCallback() {
      if (this._handle) {
        this._handle.removeEventListener('pointerdown', this._onHandlePointerDown);
        this._handle.removeEventListener('keydown', this._onKeyDown);
      }
      this.removeEventListener('pointermove', this._onPointerMove);
      this.removeEventListener('pointerup',   this._onPointerUp);
      this.removeEventListener('pointercancel', this._onPointerUp);
    }

    _setPosition(pos) {
      this._pos = Math.min(100, Math.max(0, pos));
      this.style.setProperty('--ba-pos', `${this._pos}%`);
      if (this._handle) {
        this._handle.setAttribute('aria-valuenow', Math.round(this._pos));
      }
    }

    _onHandlePointerDown(e) {
      e.preventDefault();
      this._dragging = true;
      // Capture on the slider element so pointermove/pointerup go there,
      // not to the handle — allows the slider to track movement outside the handle.
      this.setPointerCapture(e.pointerId);
      this._updateFromEvent(e);
    }

    _onPointerMove(e) {
      if (!this._dragging) return;
      this._updateFromEvent(e);
    }

    _onPointerUp(e) {
      if (!this._dragging) return;
      this._dragging = false;
      this.releasePointerCapture(e.pointerId);
    }

    _updateFromEvent(e) {
      const rect = this.getBoundingClientRect();
      const x = e.clientX - rect.left;
      this._setPosition((x / rect.width) * 100);
    }

    _onKeyDown(e) {
      const step = e.shiftKey ? 10 : 2;
      switch (e.key) {
        case 'ArrowLeft':
          e.preventDefault();
          this._setPosition(this._pos - step);
          break;
        case 'ArrowRight':
          e.preventDefault();
          this._setPosition(this._pos + step);
          break;
        case 'Home':
          e.preventDefault();
          this._setPosition(0);
          break;
        case 'End':
          e.preventDefault();
          this._setPosition(100);
          break;
      }
    }
  });
}
